import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {withTranslate} from 'react-redux-multilingual'
import {connect} from "react-redux";
import {TbChevronDown} from 'react-icons/tb';

class MainMenu extends Component {

    menuRender = (menu, key, isChild) => {
        const hasSub = !!menu.children.length;
        return (
            <li className={`cpr-nav__item${hasSub ? ' cpr-nav__item--has-sub' : ''}`} key={key}>
                <NavLink
                    exact={isChild}
                    to={`${process.env.PUBLIC_URL}${menu.link}`}
                    className={isChild ? 'cpr-nav__sublink' : 'cpr-nav__link'}
                    activeClassName="is-active"
                >
                    {menu.link === '/live' && <span className="cpr-live-dot" aria-hidden="true"/>}
                    {menu.name}
                    {hasSub && <TbChevronDown className="cpr-nav__chevron" aria-hidden="true"/>}
                </NavLink>
                {hasSub &&
                    <ul className="cpr-nav__sub">
                        {menu.children.map((child, childKey) => this.menuRender(child, childKey, true))}
                    </ul>
                }
            </li>
        )
    }

    render() {
        const {menu} = this.props;

        return (
            <nav className="cpr-nav" aria-label="Main">
                <ul className="cpr-nav__list">
                    {menu.map((item, key) => this.menuRender(item, key, false))}
                </ul>
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};
export default connect(mapStateToProps)(withTranslate(MainMenu));
